import React from 'react';
import { Link } from 'react-router-dom';
import { transcriptsAPI } from '../../services/api';
import './FileList.css';

function FileItem({ transcript, onDelete }) {
  const {
    id,
    filename,
    original_filename,
    status,
    file_size,
    audio_duration,
    created_at,
    media_available,
  } = transcript;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '-';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  const formatDuration = (seconds) => {
    if (!seconds) return '-';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const handleDownload = async () => {
    try {
      const response = await transcriptsAPI.download(id, 'txt');
      const blob = new Blob([response.data], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = original_filename.replace(/\.[^/.]+$/, '.txt');
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      console.error('Download failed:', err);
    }
  };

  const handleDownloadMedia = () => {
    const token = localStorage.getItem('token');
    const url = `/api/files/stream/${encodeURIComponent(filename)}?token=${encodeURIComponent(token)}`;
    const a = document.createElement('a');
    a.href = url;
    a.download = original_filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="file-item card">
      <div className="file-item-header">
        <div className="file-item-info">
          <h3 className="file-item-name">{original_filename}</h3>
          <div className="file-item-meta">
            <span>{formatFileSize(file_size)}</span>
            <span>{formatDuration(audio_duration)}</span>
            <span>{formatDate(created_at)}</span>
          </div>
        </div>
        <span className={`status-badge status-${status}`}>
          {status}
        </span>
      </div>

      <div className="file-item-actions">
        {status === 'completed' && (
          <>
            <Link to={`/transcript/${id}`} className="btn btn-primary btn-sm">
              View Transcript
            </Link>
            <button className="btn btn-secondary btn-sm" onClick={handleDownload}>
              Download .txt
            </button>
          </>
        )}

        {status === 'pending' && (
          <span className="text-muted">Waiting to process...</span>
        )}

        {status === 'processing' && (
          <span className="text-muted">
            <span className="spinner-small"></span>
            Processing...
          </span>
        )}

        {status === 'failed' && (
          <span className="text-muted">Transcription failed</span>
        )}

        {media_available ? (
          <button className="btn btn-secondary btn-sm" onClick={handleDownloadMedia}>
            Download Media
          </button>
        ) : (
          <span className="text-muted" title="The original media file was deleted. The transcript is still available.">
            Media deleted
          </span>
        )}
        <button
          className="btn btn-danger btn-sm"
          onClick={() => onDelete(filename)}
        >
          Delete
        </button>
      </div>
    </div>
  );
}

export default FileItem;
